import { ComponentSettings } from '@bingads-webui-theme-2018/theme-fluent';

// The styles listed here have been migrated to above package, since they might be shared across sites (CMUI and CCUI).
// If you want to fix a common issue for all sites, please do it there;
// If you want do some change only for CMUI, please config the styles after importing to this package.
export const {
  alertStyle,
  buttonInputStyle,
  btnStyle,
  btnInteractStyle,
  closeImageStyle,
  controlStyle,
  datePickerStyle,
  dropDownEditorStyle,
  entitySelectorStyle,
  floatButtonStyle,
  getBlockerStyle,
  gridInlineErrorStyle,
  helpbuttonStyle,
  InlineEditorStyle,
  inlineErrorStyle,
  internalLinkStyle,
  legacyUIBlockerStyle,
  paginationStyle,
  scrollbarStyle,
  searchboxStyle,
  spinnerKeyframe,
  statusStyle,
  toggleButtonStyle,
  uiblockerStyle,
  underlineLinkStyle,
  reactUIBlockerStyle,
} = ComponentSettings;
